export default __webpack_public_path__ + "static/media/park-enter-scan-band.b27ffd0e.mp4";